import { z } from 'zod';

export const customerFormSchema = z.object({
  name: z.string().min(1),
  companyType: z.string().optional(),
  industry: z.string().optional(),
  website: z.string().url().optional().or(z.literal('')),
  userQuota: z.coerce.number(),
});
